<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up applicant_chk com_pop">
        <div class="pop_tit _flex">
            <p>{{ state.boardItem.title }}</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>

        <div class="sch_condition_wrap">
            <div class="left _column _flex">
                <div class="date_wrap">
                    <template v-if="state.boardItem.state == 2">
                        <span class="state_tag">진행중</span>
                    </template>
                    <template v-else-if="state.boardItem.state == 1">
                        <span class="state_tag waiting">대기중</span>
                    </template>
                    <template v-else>
                        <span class="state_tag finish">마감</span>
                    </template>
                    <div class="collection_period">
                        <span>
                            <img src="img/time_icon.png" alt="" />
                            모집기간
                        </span>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.boardItem.recruitStartDate), ".") }}</span>
                        <em>-</em>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.boardItem.recruitEndDate), ".") }}</span>
                    </div>
                    <div class="end_point">
                        <span>
                            <img src="img/time_icon.png" alt="" />
                            신청종료일
                        </span>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.boardItem.applyDate), ".") }}</span>
                    </div>
                    <div class="activity_duration" v-if="state.boardItem.activeStartDate && state.boardItem.activeEndDate">
                        <span>
                            <img src="img/cal_icon.png" alt="" />
                            활동기간
                        </span>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.boardItem.activeStartDate), ".") }}</span>
                        <em>-</em>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.boardItem.activeEndDate), ".") }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="custom_scroll">
            <ul class="areaAnswer">
                <template v-if="state.list.length > 0">
                    <li v-for="(item, idx) in state.list" :key="idx">
                        <p v-text="idx + 1 + '. ' + item.title"></p>

                        <template v-if="item.type !== 3">
                            <ul v-if="item.type === 1">
                                <li v-for="answer in item.caseList" class="radio_wrap cnt p_5">
                                    <label :for="'radio_' + item.idx + '_' + answer.idx">
                                        <input
                                            type="radio"
                                            :id="'radio_' + item.idx + '_' + answer.idx"
                                            @click="item.answerList = [answer.idx]"
                                            :checked="item.answerList.indexOf(answer.idx) > -1"
                                            :disabled="!state.isPossible"
                                        />
                                        <em></em>
                                        <span v-html="answer.title"></span>
                                    </label>
                                </li>
                            </ul>
                            <ul v-if="item.type === 2">
                                <li v-for="(answer, index) in item.caseList" class="checkbox_wrap cnt p_5">
                                    <label :for="'chk_' + item.idx + '_' + answer.idx">
                                        <input
                                            type="checkbox"
                                            :id="'chk_' + item.idx + '_' + answer.idx"
                                            @click="
                                                item.answerList.indexOf(answer.idx) > -1
                                                    ? item.answerList.splice(
                                                          item.answerList.findIndex((v: any) => v === answer.idx),
                                                          1,
                                                      )
                                                    : item.answerList.push(answer.idx)
                                            "
                                            :checked="item.answerList.indexOf(answer.idx) > -1"
                                            :disabled="!state.isPossible"
                                        />
                                        <em></em>
                                        <span v-html="answer.title"></span>
                                    </label>
                                </li>
                            </ul>
                        </template>

                        <template v-if="item.type === 3">
                            <div style="border: 0; padding: 0">
                                <input type="text" v-model="item.answer" placeholder="답변을 적어주세요." :disabled="!state.isPossible" />
                            </div>
                        </template>
                    </li>
                </template>
                <li v-else>
                    <div class="tb_subject" style="text-align: center; width: 100%">등록한 신청 양식이 없습니다.</div>
                </li>

                <li class="areaSign">
                    <label style="display: block">서명</label>
                    <div>
                        <img :src="state.item.sign" />
                    </div>
                </li>
            </ul>
        </div>

        <div class="btn_wrap _default _center">
            <button class="submit_btn w_120 _gray" @click="closeModal">닫기</button>
            <button class="submit_btn w_120" v-if="state.isPossible" @click="confirm">저장</button>
        </div>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted, CommonUtils, apiService, types, getMessageByCode, ModalDefault } from "@/BaseComponent";

    export default {
        props: {
            answerInfo: {
                type: Object,
                default: {},
            },
            isPossible: {
                type: Boolean,
                default: true,
            },
        },
        emits: ["close", "callback"],
        components: { ModalDefault },
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,
                item: {} as any,
                boardItem: {} as any,
                list: [] as any,

                type: 0 as number,

                idxForRemove: 0 as number,

                itemForItem: {} as any,
                isShowCaseModal: false as boolean,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isPossible: false as boolean,
            });

            onMounted(() => {
                state.idx = props.answerInfo.boIdx;
                state.item = props.answerInfo;
                state.isPossible = props.isPossible;
                boardDetail();
                getList();
            });

            watch(props, () => {
                state.idx = props.answerInfo.boIdx;
                state.item = props.answerInfo;
                state.isPossible = props.isPossible;
                boardDetail();
                getList();
            });

            onUnmounted(() => {});

            const closeModal = () => emit("close");

            const boardDetail = async () => {
                const res = await apiService.boardActivity.detail(state.idx);
                if (res.returnCode === 0) {
                    state.boardItem = res.data;
                }
            };

            const getList = async () => {
                state.list = [];

                const res = await apiService.mypage.detailForAnswer(state.idx);
                if (res.returnCode === 0) {
                    state.list = res.data;
                    state.list.forEach((item: any) => {
                        if (item.caseList != null) {
                            item.answerList = item.caseList.filter((r: any) => r.isChecked).map((r: any) => r.idx);
                            // item.answer = [];
                            if (!item.answerList) item.answer = [];
                        }
                    });
                } else {
                    console.error(res.description);
                    state.list = [];
                }
            };

            const modifyApply = async () => {
                let isValid = true;
                state.list.forEach((item: any) => {
                    if ((item.type === 3 && item.answer === "") || (item.type !== 3 && item.answerList.length === 0)) {
                        state.modalTab = -1;
                        state.modalTitle = "안내";
                        state.modalContent = "답을 작성해주세요.";
                        state.isShowModal = true;
                        isValid = false;
                        return;
                    }
                });
                if (state.item.motivationInterest === "" && state.item.motivationApply === "") {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "동기를 작성해주세요.";
                    state.isShowModal = true;
                    return;
                }

                if (isValid) {
                    const answers = [] as Array<types.ReqApplyFormForAnswer>;

                    state.list.forEach((item: any) => {
                        answers.push({ formIdx: item.idx, answer: item.answer, caseList: item.answerList });
                    });

                    const modifyParam = {
                        interest: state.item.motivationInterest,
                        apply: state.item.motivationApply,
                        answers: answers,
                    } as types.ReqBoardApplyForModify;

                    const res: types.BaseResponse = await apiService.mypage.applyModify(state.item.idx, modifyParam);

                    if (res.returnCode === 0) {
                        emit("callback");
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const confirm = () => {
                state.modalTab = 5;
                state.modalTitle = "알림";
                state.modalContent = "정말 저장하시겠습니까?";
                state.isShowModal = true;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    modifyApply();
                }
            };

            return {
                state,
                props,
                CommonUtils,

                closeModal,

                callBackModal,
                getList,
                confirm,
            };
        },
    };
</script>

<style scoped>
    .applicant_chk {
        max-width: 1200px;
    }
    .applicant_chk .date_wrap {
        margin: 0;
    }

    .custom_scroll {
        padding-right: 10px;
        overflow-y: auto;
        max-height: calc(100vh - 450px);
    }
    .sch_condition_wrap label {
        color: #a6a6a6;
    }

    .sch_condition_wrap p {
        font-weight: bold;
    }

    ul.areaAnswer {
        margin-top: 5px;
    }

    ul.areaAnswer > li {
        border-bottom: 1px solid #d9d9d9;
        width: 100%;
        margin-bottom: 15px;
    }

    ul.areaAnwer > li p {
        font-family: Noto Sans KR;
        font-weight: 500;
        font-style: Medium;
        font-size: 16px;

        line-height: 100%;
        letter-spacing: 0%;
        color: #252525;
    }

    ul.areaAnswer > li div {
        border: 1px solid #d9d9d9;
        padding: 10px 4px 10px 10px;
        border-radius: 5px;
        margin: 15px 0;
        color: #6d6d6d;
        font-family: Noto Sans KR;
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;

        line-height: 22px;
        letter-spacing: 0%;
    }

    ul.areaAnswer > li ul > li {
        margin: 15px 0;
    }

    ul.areaAnswer > li ul > li span {
        color: #6d6d6d;
    }

    ul.areaAnswer > li ul > li input + em {
        cursor: auto;
    }

    ul.areaAnswer > li ul > li input[type="checkbox"]:checked + em {
        background-color: var(--main_color);
        border: 1px solid var(--main_color);
    }

    ul.areaAnswer > li ul > li input[type="checkbox"]:checked + em + span {
        color: #001c92;
    }

    li.areaSign div {
        max-width: 250px;
    }

    li.areaSign div img {
        width: 100%;
        height: auto;
    }

    .sch_condition_wrap {
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
    }

    .sch_condition_wrap > div {
        display: flex;
        gap: 15px 12px;
    }

    .checkbox_wrap input:disabled + em {
        border: 1px solid #c5c5c5;
        cursor: default;
    }

    input[type="text"] {
        height: 40px;
        border: 1px solid #d9d9d9;
        border-radius: 5px;
        font-family: sans-serif;
        font-size: 16px;
        padding: 10px;
        width: 100%;
    }

    textarea {
        width: 100%;
    }
</style>
